import { retainTerminalCursor } from "./terminal-cursor-lifetime";
import type { WsMessage } from "@/api/websocket";
import type { ExecutionStatus } from "@/stores/companion-store";
import type { FrameApplyContext } from "./companion-frame-reducer";

/** Native lifecycle updates describe a background task, never Denker's foreground session. */
export function applyNativeExecutionStatus(
  message: WsMessage,
  ctx: FrameApplyContext,
): boolean {
  const data = message.data;
  if (message.type !== "execution.status" || data.native_subagent !== true)
    return false;
  const id = data.execution_id as string;
  const previous = ctx.companionStore.getState().executions.get(id);
  const status = data.status as ExecutionStatus;
  ctx.companionStore.getState().addExecution({
    ...previous,
    id,
    status,
    nativeSubagent: true,
    runtimeSessionId:
      (data.runtime_session_id as string | undefined) ??
      previous?.runtimeSessionId,
    conversationId:
      (data.conversation_id as string | undefined) ?? previous?.conversationId,
    agentName: (data.agent_name as string | undefined) ?? previous?.agentName,
    spaceId: (data.project_id ?? data.space_id) as string | undefined,
    taskId: data.task_id as string | undefined,
    todos: previous?.todos ?? [],
    errorMessage: data.error_message as string | undefined,
  });
  if (["completed", "failed", "cancelled"].includes(status)) {
    ctx.conversationStore.getState().clearStreamingAssistantMessage(id);
    for (const cursor of ctx.canvasStore.getState().agentCursors.values()) {
      if (cursor.executionId === id) {
        retainTerminalCursor(ctx, cursor.agentId, id);
      }
    }
  }
  return true;
}
